<template>
  <div class="com-banner-img">
    <img :src="img" alt="">
    <div class="content sd-flex-column">
      <div class="title animated fadeInDown">{{title}}</div>
      <div class="sub">
        <div class="sub-title animated fadeInUp">{{sub}}</div>
        <div class="low-title animated fadeInUp">{{low}}</div>
      </div>
    </div>
  </div>
</template>

<script>
  /**
   * @Class: components
   * @Module: com-banner-img
   * @Description: 组件 -banner图
   * @Version: 1.0.0
   ---- Created by "Sitdown.liu<731225377@qq.com>" on "2020/4/28 15:02" ---*/
  export default {
    props: ["img", "title", "sub", "low"],
    name: "com-banner-img",
  }
</script>

<style lang="less">
  .com-banner-img {
    width: 100%;
    min-width: 1280px;
    height: 280px;
    position: relative;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;

    img {
      height: 100%;
    }

    .content {
      min-width: 700px;
      width: 70vw;
      height: 220px;
      justify-content: space-between;
      color: #ffffff;
      text-shadow: 2px 2px 5px rgba(0, 0, 0, 0.5);
      position: absolute;
      top: 3vh;
      left: 10%;

      .title {
        padding-right: 5vw;
        font-size: 2.8em;
        text-align: center;
      }

      .sub {
        padding-left: 5vw;

        .sub-title, .low-title {
          padding-top: 1vw;
          font-size: 1.5em;
          text-align: center;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/com-banner-img.vue